import { AxiosResponse } from 'axios';
import { EventRegistration } from 'shell/models/event-registration';
import { HttpResponseList } from 'shell/models/http-response';
import { EventRegistrationClient } from '../list/types';

export interface EventRegistrationsResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  eventRegistrations: Array<EventRegistrationClient>;
}

export const transformerEventRegistrations = (
  response: AxiosResponse<HttpResponseList<EventRegistration>>
): EventRegistrationsResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    eventRegistrations: data.map((eventRegistration: EventRegistration) => ({
      eventCode: eventRegistration?.codiceTipoEvento,
      eventDescription: eventRegistration?.descrizioneTipoEvento,
      destinationDescription: eventRegistration?.descrizioneTipoDestinazione,
      subscriberDescription: eventRegistration?.descrizioneSottoscrittore,
      destinationCode: eventRegistration?.codiceTipoDestinazione.toString(),
      progressive: eventRegistration?.progressivoIscrizione,
      subscriberCode: eventRegistration?.codiceSottoscrittore.toString(),
    })),
  };
};
